import * as Yup from 'yup';
import { TDay } from '../../../../../../types/e-visits';
import { ITagSelectOption } from '@hilbi/web-common/components/e-visits/select/options/types';

export interface IFormValues {
  id?: string;
  fromTime: string;
  toTime: string;
  description: string;
  blockSize: number;
  /**
   * Institutions
   */
  expertiseCode: string;
  medicalInstitutionId: string;
  /**
   * repetition config
   */
  repeat: boolean;
  repeatTo: boolean;

  fromDate: string;
  toDate?: string;
  days: TDay[];
  selectedTag: ITagSelectOption | null;
}

export const validationSchema = Yup.object({
  id: Yup.string().nullable(),
  fromTime: Yup.date().required(),
  toTime: Yup.date().required(),
  description: Yup.string(),
  blockSize: Yup.number().oneOf([15, 30, 45, 60]).required(),
  expertiseCode: Yup.string().nullable(),
  medicalInstitutionId: Yup.string().required(),
  repeat: Yup.boolean(),
  repeatFrom: Yup.boolean(),
  repeatTo: Yup.boolean(),
  fromDate: Yup.date().nullable(),
  toDate: Yup.date().nullable(),
  days: Yup.array(Yup.number().oneOf([0, 1, 2, 3, 4, 5, 6])),
});
